import { parseRange } from './parse';
import { applyRemoval } from './removal';
/** Resolve a spot key to its equilab string, or throw with the available keys for debuggability. */
export const resolveSpot = (rangeSet, spotKey) => {
    const src = rangeSet.ranges[spotKey];
    if (src === undefined) {
        throw new RangeError(`spot '${spotKey}' not in range set '${rangeSet.id}'. Available: ${Object.keys(rangeSet.ranges).join(', ')}`);
    }
    return src;
};
/**
 * The baseline WeightedRange for a spot in a range set, with optional card removal (board + known
 * holes) applied. `arch` is accepted for provenance/symmetry with §4.1 and future scaling hooks; the
 * tightness adjustment is already encoded by which range set the archetype uses, so v1 does not
 * re-scale weights here (doing so honestly would mean adding/removing combos, not multiplying - left
 * to a later session if the family charts prove too coarse).
 */
export const startingRange = (rangeSet, spotKey, opts = {}) => {
    const parsed = parseRange(resolveSpot(rangeSet, spotKey));
    return opts.dead && opts.dead.length > 0 ? applyRemoval(parsed, opts.dead) : parsed;
};
//# sourceMappingURL=starting.js.map